// extracted by mini-css-extract-plugin
export default {"container":"NestedListViewHeader-module__container--kNKM5"};